import { FormItem } from '@/components/ui/form'
import { Switch } from '@/components/ui/switch'
import { LucideIcon } from 'lucide-react'
import { cn } from '@/lib/utils'
import { Label } from '@/components/ui/label'

interface NotificationToggleItemProps {
	icon: LucideIcon
	title: string
	description: string
	isChecked: boolean
	onCheckedChange: (checked: boolean) => void
	isLoading?: boolean // To disable while an update is in progress
	className?: string
}

export function NotificationToggleItem({
	icon: Icon,
	title,
	description,
	isChecked,
	onCheckedChange,
	isLoading = false,
	className,
}: NotificationToggleItemProps) {
	const uniqueId = `notification-toggle-${title
		.toLowerCase()
		.replace(/\s+/g, '-')}`
	return (
		<FormItem
			className={cn(
				'flex flex-row items-start space-x-4 space-y-0 rounded-lg border p-4 transition-all hover:shadow-sm',
				isLoading && 'opacity-70 cursor-not-allowed',
				className
			)}>
			<div className="flex-shrink-0 mt-0.5">
				<Icon className="w-5 h-5 text-muted-foreground" />
			</div>
			<div className="flex-1 space-y-1">
				<Label
					htmlFor={uniqueId}
					className={cn(
						'text-base cursor-pointer',
						isLoading && 'text-muted-foreground'
					)}>
					{title}
				</Label>
				<p className="text-sm text-muted-foreground">{description}</p>
			</div>
			<Switch
				id={uniqueId}
				checked={isChecked}
				onCheckedChange={onCheckedChange}
				disabled={isLoading}
				aria-label={`Toggle ${title} notifications`}
			/>
		</FormItem>
	)
}
